import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MedIconXModule, MedIconChevronDownModule } from "@mk/med-icons";

import { MedLabelModule } from "../med-label/med-label.module";
import { MedMultiSelectComponent } from "./med-multi-select.component";
import { MedDirectiveSharedModule } from "../../../directives/med-directive-shared.module";
import { MedCheckboxModule } from "../med-checkbox/med-checkbox.module";
import { HasActivePipe } from "./pipes/hasActive.pipe";
import { MedMultiselectItemModule } from "../med-multiselect-item/med-multiselect-item.module";

@NgModule({
  declarations: [
    MedMultiSelectComponent,
    HasActivePipe,
  ],
  imports: [
    FormsModule,
    CommonModule,
    MedLabelModule,
    MedIconXModule,
    ReactiveFormsModule,
    MedDirectiveSharedModule,
    MedIconChevronDownModule,
    MedCheckboxModule,
    MedMultiselectItemModule,
  ],
  providers: [
    HasActivePipe,
  ],
  exports: [
    MedMultiSelectComponent,
  ],
})
export class MedMultiSelectModule { }
